import moment, { Moment } from 'moment';

import { ShiftDirection } from './types';

// Consider cleaning up this file taking into account more flexible day-shift
// related function added in week-day-shift.ts
export const getNextDayOfTheWeek = (day: number) => (day >= 7 || day < 1 ? 1 : day + 1);

export const getPrevDayOfTheWeek = (day: number) => (day <= 1 || day > 7 ? 7 : day - 1);

export const getDayAndMonthNumbers = (dates: [Moment, Moment]) => {
	return [dates[0].date(), dates[0].month() + 1, dates[1].date(), dates[1].month() + 1];
};

export const getShiftedDayOfTheWeek = (day: number, direction: ShiftDirection) => {
	switch (direction) {
		case ShiftDirection.Up:
			return getNextDayOfTheWeek(day);
		case ShiftDirection.Down:
			return getPrevDayOfTheWeek(day);
		default:
			return day;
	}
};

// Pay attention ranges like [16:00, 00:00] are treated as ones which cross midnight
// as technically 00:00 is the next day
export const isRangeIntersectsUTCMidnight = (start: Moment, end: Moment) => {
	const [utcStart, utcEnd] = [moment(start).utc(), moment(end).utc()];
	const [startMonth, startDate, endMonth, endDate] = [
		utcStart.month(),
		utcStart.date(),
		utcEnd.month(),
		utcEnd.date()
	];

	const isMonthDiffers = startMonth !== endMonth;
	const isDateDiffers = startDate !== endDate;

	return isMonthDiffers || isDateDiffers;
};
